// ── Linking out to a customer's own website ─────────────────────────────────
//
// ── THE BUG THIS EXISTS TO FIX ──────────────────────────────────────────────
// The Websites tab's "open website" icon was `href={website.domain}`, and every
// domain we store is a BARE HOSTNAME:
//
//     improveseoplugin.com    divineflowliving.com    janakimayazaremba.com
//
// A value with no scheme is a RELATIVE url. The browser resolves it against the
// page it is on, so clicking the icon opened the CMS dashboard rather than the
// customer's site — which is exactly what was reported.
//
// ── WHY THE STORED SHAPE IS NOT THE BUG ─────────────────────────────────────
// websites.routes.ts normalises every domain to `new URL(domain).hostname` with
// `www.` stripped, deliberately: that bare hostname is the key the plugin's
// connect flow matches on, so both sides agree on what "the same site" means.
// Storing a full url would have to be undone at every comparison. The LINK is
// the thing that needs an absolute url, so the conversion belongs here.

/**
 * An absolute, openable url for a stored domain — or null.
 *
 * `http://` is preserved rather than upgraded to `https://`. A rewritten scheme
 * is a different origin, and the site code is issued against the origin, so
 * "helpfully" upgrading it would send the customer somewhere their plugin is
 * not.
 *
 * Returns null when no url can be built, so the caller can render a disabled
 * control instead of a link that goes nowhere. In practice only an empty or
 * missing domain gets here — anything with characters in it parses.
 */
export function websiteHref(domain) {
  const raw = String(domain ?? '').trim();
  if (!raw) return null;
  const withScheme = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
  try {
    return new URL(withScheme).href;
  } catch (_) {
    return null;
  }
}

/**
 * The domain as it should READ on screen: no scheme, no trailing slash.
 *
 * The inverse of the above, and the form the rows have always displayed. Here
 * so the two stay a pair — a change to one that is not mirrored in the other is
 * how a row comes to link somewhere other than the name printed on it.
 */
export function websiteLabel(domain) {
  return String(domain ?? '').trim().replace(/^https?:\/\//i, '').replace(/\/+$/, '');
}
